import { render, staticRenderFns } from "./integration-list.vue?vue&type=template&id=a1c97fd4&scoped=true&"
import script from "./integration-list.vue?vue&type=script&lang=js&"
export * from "./integration-list.vue?vue&type=script&lang=js&"
import style0 from "./integration-list.vue?vue&type=style&index=0&id=a1c97fd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c97fd4",
  null
  
)

export default component.exports